/* esm.sh - d3-zoom@3.0.0 */
export * from "/*d3-zoom@3.0.0/esnext/d3-zoom.mjs";
